/**
 * Serviço de Autenticação
 *
 * Gerencia todas as operações de autenticação que vão para o Auth Service (Python/FastAPI).
 * Seguindo a arquitetura de microserviços, apenas autenticação fica no Auth Service.
 */

import { apiServiceClient } from "../config/api";

/**
 * Serviço de autenticação
 */
export const authService = {
  /**
   * Login
   * @param {string} cpf - CPF do usuário (apenas números)
   * @param {string} password
   * @returns {Promise<{access_token: string, refresh_token: string, user: Object}>}
   */
  async login(cpf, password) {
    // Limpar CPF (remover formatação, deixar apenas números)
    const cpfClean = cpf.replace(/\D/g, '');
    return apiServiceClient.post("/auth/login", {
      cpf: cpfClean,
      password,
    });
  },

  /**
   * Registro de novo usuário
   * @param {Object} userData
   * @returns {Promise<{access_token: string, refresh_token: string, user: Object}>}
   */
  async register(userData) {
    return apiServiceClient.post("/auth/register", userData);
  },

  /**
   * Refresh token
   * @param {string} refreshToken
   * @returns {Promise<{access_token: string, refresh_token: string}>}
   */
  async refresh(refreshToken) {
    return apiServiceClient.post("/auth/refresh", {
      refresh_token: refreshToken,
    });
  },

  /**
   * Busca dados do usuário atual
   * @returns {Promise<Object>}
   */
  async getMe() {
    return apiServiceClient.get("/auth/me");
  },

  /**
   * Atualiza perfil do usuário atual
   * @param {Object} userData
   * @returns {Promise<Object>}
   */
  async updateMe(userData) {
    return apiServiceClient.patch("/auth/me", userData);
  },

  /**
   * Altera senha
   * @param {string} currentPassword
   * @param {string} newPassword
   * @returns {Promise<Object>}
   */
  async changePassword(currentPassword, newPassword) {
    return apiServiceClient.post("/auth/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },

  /**
   * Busca núcleos do usuário atual
   * @returns {Promise<Array>}
   */
  async getMyNucleos(params = {}) {
    return apiServiceClient.get("/auth/me/nucleos", params);
  },

  /**
   * Busca permissões efetivas do usuário atual
   * @param {Object} params
   * @param {string} params.tenant_id
   * @param {string} params.nucleo_id
   * @returns {Promise<Object>}
   */
  async getMyEffectivePermissions(params = {}) {
    return apiServiceClient.get("/auth/me/permissions", params);
  },

  /**
   * Busca lista de tenants disponíveis para o usuário atual
   * @returns {Promise<Array>}
   */
  async getTenants(params = {}) {
    return apiServiceClient.get("/auth/tenants", params);
  },
};

export default authService;

